import http from "../http-common";

class  MeDataService {
  me() {
    return http.get("me");
  }
}

const dataservice = new MeDataService();

export default dataservice;
